module.exports = __webpack_public_path__ + "img/cok.960a7b5a.svg";